import { HiredCandidates } from "@container/employer-hired-candidates";
import AuthLayout from "@container/layout/auth";

export default function EmployerHirePage() {
    return (
        <AuthLayout>
            <HiredCandidates />
        </AuthLayout>
    );
}
